var _rect, _rect2, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.9082,
    y: 10.6367,
    width: 13.0909,
    height: 1.63636,
    fill: "#003E6B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2734,
    y: 4.90918,
    width: 13.0909,
    height: 1.63636,
    transform: "rotate(90 12.2734 4.90918)",
    fill: "#003E6B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.4545,
    cy: 11.4545,
    r: 10.4545,
    stroke: "#003E6B",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0002 27.0002L18.8184 18.8184",
    stroke: "#003E6B",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.d5291e5d94ae5b1755f86780510f1a4d.svg";
export { ForwardRef as ReactComponent };